import type { BillingInterval } from '@prisma/client';
import type { ContractTerminationOptions } from '@weft/api-definition';
import { CONTRACT_TERMINATION_OPTIONS } from '@weft/api-definition';
import { getBillingIntervalInMonths, getCurrentInvoiceBillingCycle } from '@weft/services';
import { getTomorrow, raiseUnreachable } from '@weft/utils';
import { dayjs } from '@weft/utils';
import type { PlanSettingsSelectItem } from 'apps/app/src/pages/plans/CreatePlanPage/create-plan-page-components/PlanSettingsSelect';
import { formatDate } from 'apps/app/src/utils/date';

export const getNewContractStartDateByTerminationOption = (
  terminationOption: ContractTerminationOptions, 
  contractStartDate: Date, 
  billingInterval: BillingInterval,
): Date => {
  switch (terminationOption) {
    case CONTRACT_TERMINATION_OPTIONS.Immediate:
      return getTomorrow().startOf('day').utc(true).toDate();
    case CONTRACT_TERMINATION_OPTIONS.EndOfBillingCycle: {
      const billingIntervalInMonths = getBillingIntervalInMonths(billingInterval);
      const currentBillingCycle = getCurrentInvoiceBillingCycle(dayjs(contractStartDate), billingIntervalInMonths);
  
      return dayjs(currentBillingCycle.endTime).add(1, 'day').utc(true).toDate();
    }
    default:
      return raiseUnreachable(terminationOption);
  }
};
  
export const getTerminationOptionsValues = (nextBillingCycleStartDate: Date): PlanSettingsSelectItem<ContractTerminationOptions>[] => [
  {
    value: CONTRACT_TERMINATION_OPTIONS.Immediate,
    label: 'Immediate - from midnight',
  },
  {
    value: CONTRACT_TERMINATION_OPTIONS.EndOfBillingCycle,
    label: `End of billing cycle - starts on ${formatDate(nextBillingCycleStartDate)}`,
  },
];